import type { Workbook } from 'exceljs';

export const writeExcelFile = async (workBook: Workbook, fileName: string) => {
  const buffer = await workBook.xlsx.writeBuffer();

  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`;
  link.click();
  // Clean up the URL object after the download starts
  window.URL.revokeObjectURL(link.href);
};
